<template>
    <div id="loan-supplier-detail">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div v-if="source.supplier_id != null" id="supplier-detail" class="mb-4 vx-card p-2">
                    <div class="flex justify-between">
                        <h6 class="success bold">PROVEEDOR</h6>
                        <project-supplier-selector v-if="hasAccess" :isFromFolder="true" :supplier.sync="supplier"
                            :project_id="source.id"></project-supplier-selector>
                    </div>
                    <vs-list>
                        <vs-list-item title="SID">
                            <div @click.stop="handleSelected(supplier)" class="success clickable">{{ supplier.id }}
                            </div>
                        </vs-list-item>
                        <vs-list-item title="Nombre comercial">{{ supplier.tradename }}</vs-list-item>
                        <template v-if="supplier_agent != null">
                            <vs-list-item title="Agente">{{ supplier_agent.name }}</vs-list-item>
                            <vs-list-item v-if="supplier_agent.phone != null" title="Tel.">
                            {{ supplier_agent.phone.country_calling_code }} {{ phoneFormat(supplier_agent.phone.phone) }}
                                </vs-list-item>
                            <vs-list-item title="Email">{{ supplier_agent.user.email }}</vs-list-item>
                        </template>
                        <template v-else>
                            <vs-list-item title="Agente">No asignado</vs-list-item>
                        </template>
                    </vs-list>
                    <vs-divider></vs-divider>
                    <due-portfolio-supplier-stats :realTime="true" :supplierId="source.supplier.id" />
                </div>
                <div v-else class="mb-4 vx-card p-2">
                    <div class="flex justify-between">
                        <h6 class="success bold">PROVEEDOR</h6>
                        <vs-button 
                            v-if="hasAccess"
                            size="small" 
                            color="warning" 
                            type="line" 
                            class="mb-1"
                            @click.stop="showFormPromptSupplierAssignment = true">
                            Asignar proveedor
                        </vs-button>
                    </div>
                    <vs-list>
                        <vs-list-item title="SID">No asignado</vs-list-item>
                        <vs-list-item title="Nombre comercial">No asignado</vs-list-item>
                        <vs-list-item title="Agente">No asignado</vs-list-item>
                    </vs-list>
                </div>
            </div>
        </div>

        <vs-popup v-if="showFormPromptSupplierAssignment" id="supplier-assignment" title="Asignar un proveedor" :active.sync="showFormPromptSupplierAssignment">
            <LoanSupplierSelector 
                :loan="source"
                @updated="supplierAssgined"
                ></LoanSupplierSelector>
        </vs-popup>
    </div>
</template>

<script>
import ProjectSupplierSelector from '../../../../../components/project-details/ProjectSupplierSelector.vue';
import DuePortfolioSupplierStats from "@components/supplier/DuePortfolioSupplierStats";
import LoanSupplierSelector from './LoanSupplierSelector.vue';
import formatHelper from '@mixins/formatHelper';

export default {
    name: "LoanSupplierDetail",
    mixins: [formatHelper],
    data: () => ({
        showFormPromptSupplierAssignment: false
    }),
    props: {
        source: String
    },
    components: {
        ProjectSupplierSelector,
        DuePortfolioSupplierStats,
        LoanSupplierSelector
    },
    computed: {
        supplier() {
            return this.source.supplier;
        },
        supplier_agent() {
            return this.source.supplier_agent_id != null ? this.source.agent : null;
        },
        hasAccess() {
            return this.currentUser.user_id == this.operatorUser;
        }
    },
    methods: {
        async handleSelected(supplier) {
            window.open(`/suppliers/${supplier.id}`, '_blank');
        },
        supplierAssgined() 
        {
            window.location.reload();
        }
    }
}
</script>